<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<div class="grid lg:grid-cols-3 md:grid-cols-1">
			<div class="col-span-2" id="rmcs" style="width: 100%;overflow-x: hidden;">
				<div style="" v-if="canBuy || canSell" class="mb-4">
					<div class="mb-8 w-full ml-0" style="align-items: center; align-items: center;display: flex; flex-direction: row;width: 100%;overflow-x: scroll;">
						<!--<h4 class="font-bold">Sổ lệnh</h4>-->
						<div class="mr-2 ml-0" :key="`${upStatus}--1`" style="min-width: 100px;">
							<vs-button title="Tìm theo Sản phẩm phù hợp" class="font-bold w-full" :color="'#626262'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
						</div>
						<div class="mr-2" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in statusList">
							<vs-button title="Tìm theo Sản phẩm phù hợp" class="font-bold w-full" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
						</div>
					</div>
					<div style="height: 35vh; overflow-y: auto;">
						<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="shadow-none border-none table-auto" stripe :data="$store.state.moduleProduct && $store.state.moduleProduct.myOrders" @sort="handleSort">
							
							<template slot="thead">
								<vs-th sort-key="id" style="min-width:80px;"><h6 class="uppercase font-bold">Mã</h6></vs-th>
								<vs-th v-if="canSelectSupplier" sort-key="product_id" style="min-width:120px;"><h6 class="uppercase font-bold">NCC</h6></vs-th>
								<vs-th sort-key="product_id" style="min-width:120px;"><h6 class="uppercase font-bold">Loại PP</h6></vs-th>
								<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Đơn giá</h6></vs-th>
								<vs-th sort-key="quantity" style="min-width:100px;"><h6 class="uppercase font-bold">KL</h6></vs-th>
								<vs-th sort-key="created_at" style="min-width:100px;" v-if="canSell"><h6 class="uppercase font-bold">Ngày tạo</h6></vs-th>
								<vs-th sort-key="created_at" style="min-width:100px;" v-if="canSell"><h6 class="uppercase font-bold">Nơi giao</h6></vs-th>
								<vs-th sort-key="updated_at" style="min-width:100px;" v-if="canBuy"><h6 class="uppercase font-bold">Ngày ĐX</h6></vs-th>
								<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">Trạng thái</h6></vs-th>
								<vs-th sort-key="" style="min-width:100px;"><h6 class="uppercase font-bold"></h6></vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
									<vs-td>
										<p class="word-break uppercase" :style="{color: ((canBuy && canSell) ? ((tr.type == 1) ? 'rgb(99, 186, 70)' : 'rgb(222, 0, 0)') : '#626262')}">
											#{{ tr.id }}
										</p>
									</vs-td>
									<vs-td v-if="canSelectSupplier">
										<p class="word-break">
											{{ tr.supplier_name }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ tr.product ? tr.product.name : '-' }}
										</p>
									</vs-td>
									<vs-td>
										<p :class="{ 'word-break': 1 }">
											{{ $helper.numFormat(tr.price) }}
										</p>
									</vs-td>
									<vs-td>
										<p :class="{ 'word-break': 1 }">
											{{ $helper.numFormat(tr.quantity) }}<sup v-if="tr.quantity_extra" style="color: rgb(210, 172, 36)"> {{(tr.quantity_extra > 0 ? '+' :'') + $helper.numFormat(tr.quantity_extra)}}</sup>
										</p>
									</vs-td>
									<vs-td v-if="canSell">
										<p class="word-break uppercase">
											{{ $helper.momentFormatLocale(tr.created_at) }}
										</p>
									</vs-td>
									<vs-td v-if="canSell">
										<p class="word-break uppercase">
											{{ tr.matching ? tr.matching.cus_address : '' }}
										</p>
									</vs-td>
									<vs-td v-if="canBuy">
										<p class="word-break uppercase">
											{{ tr.status >= 2 && tr.status != 16 ? $helper.momentFormatLocale(tr.matching_buy ? tr.matching_buy.created_at : (tr.matching ? tr.matching.created_at : tr.updated_at) ) : '-' }}
										</p>
									</vs-td>
									<vs-td :set="statusDirective = $helper.getStatusAndDirective(tr.status)">
										<p :class="{ 'word-break': 1 }">
											<label :class="statusDirective.directive">
												{{ statusDirective.name}}
											</label>
										</p>
									</vs-td>
									<vs-td >
										<div class="flex items-center justify-start">
											<div style="cursor: pointer; padding-left: 6px;" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status < 2" @click.stop="onClickCancelOrder(tr.id, $event)">
												<i class="nucleo mr-1 text-danger nucleo-trash-can" />
												<span class="label text-danger">Hủy đơn</span>
											</div>
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status < 2" @click.stop="onClickEditOrder(tr, $event)">
												<i class="nucleo mr-1 text-primary nucleo-edit" />
												<span class="label text-primary">Sửa đơn</span>
											</div>
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>2 && tr.status != 8 && tr.status != 16 && tr.type == 2" @click.stop="onClickShippingOrder(tr, $event)">
												<i class="nucleo mr-1 text-primary nucleo-file-text" />
												<span class="label text-primary">Vận đơn</span>
											</div>
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=2 && tr.status != 8 && tr.status != 16" @click.stop="onClickSellerRating(tr, $event)">
												
												<span class="label text-warning flex" style="align-items: center;"><i class="material-icons" style="width: 22px; margin-right: 5px; font-size: 22px;">star_rate</i>Đánh giá</span>
											</div>
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=1 && tr.status != 8 && tr.status != 16 && tr.type == 1" @click.stop="onClickChooseSells(tr, $event)">
												<i class="nucleo mr-1 text-primary nucleo-file-text" />
												<span class="label text-primary">Đơn phù hợp</span>
											</div>
											<!--<div id="test" style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=2 && tr.type==2" @click.stop="printOrder(tr, $event)">
												<i class="nucleo mr-1 text-primary nucleo-file-text" />
												<span class="label text-primary">In phiếu</span>
											</div>-->
										</div>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
					<div class="w-full center mt-4">
						<CbsPagination :total="total" v-model="page"></CbsPagination>
					</div>
				</div>

				<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 bs-box" style="height: 35vh">
					<div style="padding-right: 5px;" class="mobible-rm">
						<div class="b-box">
							<label style="color: #63BA46; font-weight: 900;">SẢN PHẨM CẦN MUA</label>
							<div style="height: 35vh; overflow-y: auto;">
								<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="mt-4" :data="dashboardBuys">
									
									<template slot="thead">
										<vs-th ><h6 class="font-bold">Loại PP <br />&nbsp;</h6></vs-th>
										<vs-th ><h6 class="font-bold">Khối lượng <br /> KG</h6></vs-th>
										<vs-th ><h6 class="font-bold">Giá tiền <br /> VND</h6></vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :key="indextr" v-for="(tr, indextr) in dashboardBuys" @click.native="handleClickItemRowNow($event, tr)">
											<vs-td>
												<p class="word-break">
													{{ tr.product }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.quantity) }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.price) }}
												</p>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</div>
						</div>
					</div>
					<div style="padding-left: 5px;" class="mobible-rm">
						<div class="s-box">
							<label style="color: #DE0000; font-weight: 900;">SẢN PHẨM CẦN BÁN</label>
							<div style="height: 35vh; overflow-y: auto;">
								<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="mt-4" :data="dashboardSells">
									
									<template slot="thead">
										<vs-th ><h6 class="font-bold">Loại PP <br />&nbsp;</h6></vs-th>
										<vs-th ><h6 class="font-bold">Khối lượng <br /> KG</h6></vs-th>
										<vs-th ><h6 class="font-bold">Giá tiền <br /> VND</h6></vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :key="indextr" v-for="(tr, indextr) in dashboardSells" @click.native="handleClickItemRowNow($event, tr)">
											<vs-td>
												<p class="word-break">
													{{ tr.product }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.quantity) }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.price) }}
												</p>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="padding-left: 10px;" ref="overviewBox" class="pr-box">
				<div class="d-box" style="height: calc(35vh + 40px + 36px + 2rem); margin-bottom: 1.5rem;" v-if="canBuy || canSell">
					<div class="flex flex-row justify-between items-center">
						<label class="dash-label" style="color: #030960">THỐNG KÊ</label>
						<div class="flex flex-row justify-between items-center">
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': overviewDateType == 2 ? 1 : 0}" @click="changeOverviewTypeTo(2)">7 ngày</label>
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': overviewDateType == 3 ? 1 : 0}" @click="changeOverviewTypeTo(3)">30 ngày</label>
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': overviewDateType == 4 ? 1 : 0}" @click="changeOverviewTypeTo(4)">90 ngày</label>
						</div>
					</div>
					<div style="background: rgba(255, 255, 255, 0.5); box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4); border-radius: 10px; margin-top: 30px; height: 96px; padding: 16px;">
						<label style="font-weight: 400; font-size: 12px; color: #000000;">Tổng giá trị đơn hàng</label>
						<label style="font-weight: 700; font-size: 24px; color: #000000; display: block;">{{$helper.numFormat(overviewItem.totalPrice)}} vnd</label>
					</div>
					<div class="flex flex-row justify-between items-center" style="margin-top: 20px;">
						<div style="background: #50ACA6; border-radius: 10px; width: 45%; height: 178px; padding: 16px; display: flex; justify-content: space-between; flex-direction: column;overflow: hidden;">
							<label style="font-weight: 700; font-size: 14px; color: #FFFFFF;">Tổng đơn hàng</label>
							<label style="font-weight: 700; font-size: 40px; color: #FFFFFF;white-space: pre;">{{$helper.numFormat(overviewItem.totalOrder)}} <label style="font-size: 14px;">đơn</label></label>

						</div>
						<div style="background: #4DBBF9; border-radius: 10px; width: 45%; height: 178px; padding: 16px; display: flex; justify-content: space-between; flex-direction: column;overflow: hidden;">
							<label style="font-weight: 700; font-size: 14px; color: #FFFFFF;">Tổng sản lượng</label>
							<label style="font-weight: 700; font-size: 40px; color: #FFFFFF;white-space: pre;">{{$helper.numFormat(overviewItem.totalQuantity / 1000)}} <label style="font-size: 14px;">tấn</label></label>
						</div>
					</div>
				</div>

				<div class="d-box" style="height: calc(35vh + 99px - 1.5rem); overflow-y: hidden;">
					<div class="flex flex-row justify-between items-center mb-2">
						<label class="dash-label" style="color: #030960">THÔNG TIN THỊ TRƯỜNG</label>
						<!--<div class="flex flex-row justify-between items-center">
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': chartDateType == 1 ? 1 : 0}" @click="changeChartTypeTo(1)">7 ngày</label>
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': chartDateType == 2 ? 1 : 0}" @click="changeChartTypeTo(2)">30 ngày</label>
							<label :class="{'dash-label': 1, 'mx-1': 1, 'cursor-pointer': 1, 'label-active': chartDateType == 3 ? 1 : 0}" @click="changeChartTypeTo(3)">90 ngày</label>
						</div>-->
					</div>
					<div style="height: calc(35vh + 20px); overflow-y: auto;">
						<div class=" mt-2 mb-2" :key="idxMatched" v-for="(matchedObj, idxMatched) in matchedList">
							<div class="flex flex-row">
								<svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M4.99295 12.984C4.77572 12.9838 4.56433 13.0543 4.39075 13.1849C4.21716 13.3155 4.09082 13.4991 4.03083 13.7079C3.97084 13.9166 3.98047 14.1393 4.05825 14.3421C4.13603 14.5449 4.27774 14.7169 4.46195 14.832L7.14995 17.52C7.24286 17.6129 7.35315 17.6865 7.47451 17.7367C7.59588 17.7869 7.72595 17.8128 7.8573 17.8127C7.98865 17.8127 8.1187 17.7868 8.24004 17.7365C8.36137 17.6861 8.4716 17.6124 8.56445 17.5195C8.65729 17.4266 8.73093 17.3163 8.78115 17.195C8.83137 17.0736 8.8572 16.9435 8.85715 16.8122C8.8571 16.6808 8.83119 16.5508 8.78088 16.4294C8.73057 16.3081 8.65686 16.1979 8.56395 16.105L7.44295 14.985H14.9929C15.2582 14.985 15.5125 14.8797 15.7001 14.6921C15.8876 14.5046 15.9929 14.2502 15.9929 13.985C15.9929 13.7198 15.8876 13.4654 15.7001 13.2779C15.5125 13.0904 15.2582 12.985 14.9929 12.985H4.99295V12.984ZM19.0069 11.016C19.2242 11.0162 19.4356 10.9457 19.6091 10.8151C19.7827 10.6845 19.9091 10.501 19.9691 10.2922C20.0291 10.0834 20.0194 9.86077 19.9416 9.65795C19.8639 9.45513 19.7222 9.28315 19.5379 9.16802L16.8499 6.48002C16.6623 6.29251 16.4079 6.18722 16.1426 6.18732C15.8773 6.18741 15.623 6.29288 15.4354 6.48052C15.2479 6.66816 15.1427 6.9226 15.1427 7.18787C15.1428 7.45314 15.2483 7.70751 15.4359 7.89502L16.5569 9.01502H9.00695C8.74173 9.01502 8.48738 9.12038 8.29984 9.30791C8.11231 9.49545 8.00695 9.7498 8.00695 10.015C8.00695 10.2802 8.11231 10.5346 8.29984 10.7221C8.48738 10.9097 8.74173 11.015 9.00695 11.015H19.0069V11.016Z" fill="#63BA46"/>
								</svg>
								<label style="font-size: 14px; font-weight: 400"><label style="font-weight: 500; color: #63BA46">{{matchedObj.product}}</label> đã được đề xuất với khối lượng <label style="font-weight: 500;">{{$helper.numFormat(matchedObj.quantity)}}</label> (KG) và giá <label style="font-weight: 500;">{{$helper.numFormat(matchedObj.price)}}</label> (VND)</label>
							</div>
							<label style="display: block; font-size: 12px; margin-left: 24px;" class="pl-2">Lúc {{$helper.momentFormatLocale(matchedObj.created_at, 'HH:mm DD/MM/YYYY')}}</label>
						</div>
					</div>
				</div>
			</div>
		</div>

		<OrderForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
		<OrderFormNow :isPopupActive="orderFormNowDialog" @closePopup="toggleOrderNowSidebar" :data="orderFormNowData" />
		<OrderDetail :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />
		<KcsForm :isPopupActive="shippingDialog" @closePopup="toggleShippingDialog" :data="shippingData" />
		<ChooseSells :isPopupActive="sellsDialog" @closePopup="toggleSellsDialog" :data="sellsData" />
		<SellerRatingForm :isPopupActive="sellerRatingDialog" @closePopup="toggleSellerRatingDialog" :data="sellerRatingData" />

		<div class="btn-order-action">
			<button class="vs-component vs-button w-48 font-bold vs-button-primary vs-button-filled ml-4 mr-4" v-if="!customerDialog" @click="handleOrderAction(1)">Mua</button>
			<button class="vs-component vs-button w-48 font-bold vs-button-primary vs-button-filled ml-4 mr-4" v-if="!customerDialog && !shippingDialog" @click="handleOrderAction(2)">Bán</button>
		</div>
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderFormNow from "./OrderFormNow.vue";
import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";
import vSelect from "vue-select";
import { GChart } from 'vue-google-charts/legacy';

const DATE_TYPE = {
	1: '7 NGÀY',
	2: '30 NGÀY',
	3: '90 NGÀY',
};

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm,
		vSelect,
		GChart,
		OrderFormNow
	},
	data() {
		return {
			matchedList: [],
			canBuy: false,
			canSell: false,
			chartData: [],
			chartOptions: {
				curveType: 'function',
				legend: { position: 'bottom' },
				width: 800,
				height: 600,
			},
			chartDateType: 1,
			overviewItem: {
				totalPrice: 0,
				totalOrder: 0,
				totalQuantity: 0,
			},
			overviewDateType: 2,
			currentProdSelected: null,
			product: null,
			prods: [],
			isAll: false,
			statusList: [
				// {
				// 	id: -1,
				// 	name: window.innerWidth > 600 ? 'Tất cả' : 'Tất cả',
				// 	active: 0,
				// 	color: '#626262',
				// },
				{
					id: 0,
					name: window.innerWidth > 600 ? 'Đang chờ' : 'Đang chờ',
					active: 0,
					color: 'primary',
				},
				{
					id: 1,
					name: window.innerWidth > 600 ? 'Sản phẩm phù hợp' : 'Sản phẩm phù hợp',
					active: 0,
					color: 'warning',
				},
				{
					id: 2,
					name: window.innerWidth > 600 ? 'Đề xuất giao dịch' : 'Đề xuất giao dịch',
					active: 0,
					color: 'success',
				},
				{
					id: 4,
					name: window.innerWidth > 600 ? 'Duyệt mua' : 'Duyệt mua',
					active: 0,
					color: '#030960',
				},
				{
					id: 2056,
					name: window.innerWidth > 600 ? 'Đang VC' : 'Đang VC',
					active: 0,
					color: '#D2AC24',
				},
				{
					id: 64,
					name: window.innerWidth > 600 ? 'Hoàn thành VĐ' : 'HT VĐ',
					active: 0,
					color: '#030960',
				},
				{
					id: 128,
					name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
					active: 0,
					color: '#057FBB',
				},
			],
			orderFormNowDialog: false,
			orderFormNowData: {},
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now(),
			dashboardSells: [],
			dashboardBuys: [],
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.myOrdersTotal / this.$store.state.moduleProduct.limit);
		},
	},
	methods: {
		changeChartTypeTo(type) {
			this.chartDateType = type;
			this.getDashboardPriceHistories();
		},
		changeOverviewTypeTo(type) {
			this.overviewDateType = type;
			this.getOverviewOrder();
		},
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=800, width=800');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickSellerRating(data, event) {
			let matchingId = 0;
			let cusName = '';
			if (data.type == 2) {
				matchingId = data.matching.id || '';
				cusName = data.matching.cus_name || '';
			} else {
				matchingId = data.matching_buy.id || '';
				cusName = data.matching_buy.supplier_name || '';
			}
			this.sellerRatingData = {
				type: data.type,
				id: data.id,
				matchId: matchingId,
				buyer_name: cusName,
				rating: data.rating,
				rating_note: data.rating_note
			};
			this.sellerRatingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickShippingOrder(data, event) {
			this.shippingData = {
				id: data.matching.id
			};
			this.shippingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickChooseSells(data, event) {
			this.sellsData = {
				id: data.id,
				status: data.status,
			};
			this.sellsDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload).then(response => {
					console.log('fetchProducts: ', response);
					let dataProds = response.data || [];
					dataProds.sort(function(a, b) {
						var keyA = new Date(a.updated_at),
							keyB = new Date(b.updated_at);
						// Compare the 2 dates
						if (keyA < keyB) return 1;
						if (keyA > keyB) return -1;
						return 0;
					});
					this.product = dataProds.length ? dataProds[0].id : 0;
					this.prods = dataProds;
				});
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			// console.log(this.statusList);
			this.filters.statuses = !isAll ? statuses : [];
			const payload = {
				filters: this.filters,
				id: 0,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				sort: this.sort
			};
			try {
				await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getDashboardBuyList() {
			const payload = {};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardBuyList", payload);
				console.log('buys: ', sells);
				this.dashboardBuys = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardSellList() {
			// const payload = {};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardSellList", {});
				console.log('sells: ', sells);
				this.dashboardSells = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardMatching() {
			// const payload = {};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardMatching", {});
				console.log('getDashboardMatching: ', sells);
				this.matchedList = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getOverviewOrder() {
			const payload = {
				dateType: this.overviewDateType,
			};
			try {
				let overview = await this.$store.dispatch("moduleProduct/getOverviewOrder", payload);
				console.log('getOverviewOrder: ', overview);
				if (overview) {
					this.overviewItem.totalPrice = overview.total_price;
					this.overviewItem.totalOrder = overview.total_order;
					this.overviewItem.totalQuantity = overview.total_quantity;
				}
				// this.dashboardSells = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardPriceHistories() {

			this.chartData = [];
			const payload = {
				id: this.currentProdSelected.id || 0,
				type: this.chartDateType
			};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardPriceHistories", payload);
				if (sells.data && sells.data.length) {
					let chartDataTmp = [
						['Date', 'Price']
					];

					for (let k in sells.data) {
						let p = sells.data[k];
						if (p) {
							chartDataTmp.push([p.x, p.y]);
						}
					}

					console.log('chartDataTmp: ', chartDataTmp);
					this.chartData = chartDataTmp;
				}
			} catch (error) {
				console.log(error.message);
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		handleClickItemRowNow(event, user) {
			// const eventClasses = event.target && event.target.className;
			// // show detail dialog if click target is not below classes
			// if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
			// 	// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			// 	this.orderFormNowData = user;
			// 	this.toggleOrderNowSidebar(true);
			// }
			user.orderNow = 1;
			this.orderFormNowData = user;
			this.toggleOrderNowSidebar(true);
		},
		toggleOrderNowSidebar(val = false) {
			this.orderFormNowDialog = val;
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
		product() {
			console.log('this.product: ', this.product);
			this.currentProdSelected = this.prods.find(p => {
				return p.id == this.product;
			});
			this.getDashboardPriceHistories();
		}
	},
	mounted() {
		// console.log('this.$refs.overviewBox: ', this.$refs.overviewBox.clientWidth);
		// this.chartData = [
		// 		['Year', 'Sales'],
		// 		['2004', 1000],
		// 		['2005', 1170],
		// 		['2006', 660],
		// 		['2007', 1030],
		// 	];
		this.chartOptions = {
			title: '',
			curveType: 'function',
			legend: { position: 'none' },
			width: this.$refs.overviewBox.clientWidth - 40,
			height: 300,
			chartArea: {
				left: 40,
				top: 20,
				width: '90%',
				height: '85%'
			}
		};
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
		this.getProducts();
		this.getDashboardSellList();
		this.getDashboardBuyList();
		this.getOverviewOrder();
		this.getDashboardMatching();

		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { supplier_can_select = false, user_can_buy = false, user_can_sell = false } = permissions;
			if (user_can_buy) {
				this.canBuy = true;
			}
			if (user_can_sell) {
				this.canSell = true;
			}
			if (supplier_can_select) {
				this.canSelectSupplier = true;
			}
			this.userToken = token;

			if (user_can_buy && !user_can_sell) {
				this.statusList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 1,
						name: window.innerWidth > 600 ? 'Sản phẩm phù hợp' : 'Sản phẩm phù hợp',
						active: 0,
						color: 'warning',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Đề xuất giao dịch' : 'Đề xuất giao dịch',
						active: 0,
						color: 'success',
					},
					{
						id: 4,
						name: window.innerWidth > 600 ? 'Duyệt mua' : 'Duyệt mua',
						active: 0,
						color: '#030960',
					},
					{
						id: 2056,
						name: window.innerWidth > 600 ? 'Đang VC' : 'Đang VC',
						active: 0,
						color: '#D2AC24',
					},
					{
						id: 64,
						name: window.innerWidth > 600 ? 'Hoàn thành VĐ' : 'HT VĐ',
						active: 0,
						color: '#030960',
					},
					{
						id: 128,
						name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
						active: 0,
						color: '#057FBB',
					},
				];
			} else if (!user_can_buy && user_can_sell) {
				this.statusList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Đề xuất giao dịch' : 'KL',
						active: 0,
						color: 'success',
					},
					{
						id: 4,
						name: window.innerWidth > 600 ? 'Duyệt mua' : 'Duyệt mua',
						active: 0,
						color: '#030960',
					},
					{
						id: 64,
						name: window.innerWidth > 600 ? 'Hoàn thành VĐ' : 'HT VĐ',
						active: 0,
						color: '#030960',
					},
					{
						id: 128,
						name: window.innerWidth > 600 ? 'Đã thanh toán' : 'TT',
						active: 0,
						color: 'dark',
					},
				];
			}
		}
		if (typeof localStorage === 'object' && localStorage) {
			let forceRelogin = localStorage.getItem('relogin');
			if (!forceRelogin || parseInt(forceRelogin) < 1) {
				localStorage.removeItem("accessToken");
				this.$acl.change("guest");
				localStorage.removeItem("userInfo");
				this.$router.push("/pages/login").catch(() => {});
				window.location = '/';
			}
		}
	},
};
</script>

<style lang="scss">
.lbl-dbg {
	margin-top: 10px;
	margin-bottom: 10px;
	font-weight: 600;
	font-size: 12px;
	color: #000000;
}
.prod-price {
	font-weight: 500;
	font-size: 24px;
	color: #057FBB;
	padding-left: 10px;
}
.dash-select {
	margin-top: 10px;
}
.dash-select .vs__selected {
	font-weight: 600;
    font-size: 24px;
    color: #000000;
    margin-left: 0;
    padding-left: 0;
}
.dash-select .vs__dropdown-toggle {
	border: none !important;
}
.d-box {
	background: #FFFFFF;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 5px;
	// min-height: 43.5vh;
	// max-height: 43.5vh;
	overflow-y: auto;
	padding: 22px;
	// margin-bottom: 25px;
}
.label-active {
	color: #030960 !important;
	text-decoration: underline !important;
}
.dash-label {
	font-weight: 700;
	font-size: 14px;
	line-height: 18px;
	/* identical to box height */


	// 
	color: rgba(0, 0, 0, 0.3);
}
.b-box {
	min-width: 35vh !important;
	padding: 23px;
	// margin-right: 10px;
	background: #FFFFFF;
	border: 2px solid #63BA46;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
}
.s-box {
	min-width: 35vh !important;
	padding: 23px;
	// margin-left: 10px;
	background: #FFFFFF;
	border: 2px solid #DE0000;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
}
.b-box .vs-con-tbody, .s-box .vs-con-tbody {
	border: none !important;
	background: transparent !important;
}

.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
@media screen and (max-width: 991px) {
	.bs-box {
		height: auto !important;
		display: block !important;
	}
	.bs-box .mobible-rm {
		margin-right: 0 !important;
		margin-left: 0 !important;
		margin-bottom: 20px;
		padding: 0 !important;
	}
	#rmcs {
		grid-column: span 1 !important;
		grid-column-start: span 1 !important;
		grid-column-end: span 1 !important;
	}
	.pr-box {
		padding-left: 0 !important;
	}
	.btn-order-action {
		display: flex;
		right: 0 !important;
	}
}

.vs-button--text {
	white-space: nowrap !important;
}
</style>
